import 'scrolling-element'
import smoothscroll from 'smoothscroll-polyfill'

import Vue from 'vue'
import './components'
import store from './store'
import './assets/styles/main.css'
import vhCheck from 'vh-check'

smoothscroll.polyfill()
Vue.config.productionTip = false

if (document.querySelector('app')) {
  new Vue({
    el: '#app',
    store,
    delimiters: ['${', '}']
  })
}

vhCheck()